import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { MassiveResponse } from "src/app/modules/massive-actions/models/massive.model";
import { IntervalPrice } from "../../interfaces/intervalPrice";
import { ServiceConceptData } from "../../interfaces/serviceConceptData";
import { ServiceConceptDataReq } from "../../interfaces/serviceConceptDataReq";
import { ContractResponse } from "src/app/modules/contract/interfaces/contract";
import { ContractData } from "src/app/modules/contract/interfaces/contractData";
import { ContractDetailEditForm, DebRepayment, DebRepaymentForm, DebRepaymentAddForm, ContractDetailsAddForm, DeactivateServiceConceptRequest } from '../../interfaces/serviceConcept';
import { FormGroup } from "@angular/forms";

export namespace ServiceConceptActions {

  @logDispatcher
  export class GetContract {
    static readonly type = "[ServiceConcepts] GetContract"
    constructor(public contractId: number) {}
  }

  @logDispatcher
  export class GetContractSuccess {
    static readonly type = "[ServiceConcepts] GetContractSuccess"
    constructor(public contract: ContractResponse) {}
  }

  @logDispatcher
  export class GetContractDetails {
    static readonly type = '[ServiceConcepts] GetContractDetails';
    constructor(public contractId: number) { }
  }

  @logDispatcher
  export class GetDebRepayments {
    static readonly type = '[ServiceConcepts] GetDebRepayments';
    constructor(public serviceConceptId: number) { }
  }

  @logDispatcher
  export class GetDebRepaymentsSuccess {
    static readonly type = '[ServiceConcepts] GetDebRepaymentsSuccess';
    constructor(public debRepayments: DebRepayment[], public serviceConceptId: number) { }
  }

  @logDispatcher
  export class AddContract {
    static readonly type = "[ServiceConcepts] AddContract"
    constructor(public contractData: ContractData) {}
  }

  @logDispatcher
  export class AddContractSuccess {
    static readonly type = "[ServiceConcepts] AddContractSuccess"
    constructor(public contractData: ContractData, public response: any) {}
  }

  @logDispatcher
  export class EditContract {
    static readonly type = "[ServiceConcepts] EditContract"
    constructor(public contractDataForm: FormGroup, public user: string) {}
  }

  @logDispatcher
  export class EditContractSuccess {
    static readonly type = "[ServiceConcepts] EditContractSuccess"
    constructor(public contractDataForm: FormGroup) {}
  }

  @logDispatcher
  export class AddServiceConcept {
    static readonly type = "[ServiceConcepts] AddServiceConcept"
    constructor(public conceptServiceData: ServiceConceptData, public user: string) {}
  }

  @logDispatcher
  export class AddServiceConceptSuccess {
    static readonly type = "[ServiceConcepts] AddServiceConceptSuccess"
    constructor(public conceptServiceData: ServiceConceptDataReq) {}
  }

  @logDispatcher
  export class EditServiceConcept {
    static readonly type = "[ServiceConcepts] EditServiceConcept"
    constructor(public serviceConceptData: ServiceConceptData, public user: string) {}
  }

  @logDispatcher
  export class EditServiceConceptSuccess {
    static readonly type = "[ServiceConcepts] EditServiceConceptSuccess"
    constructor(public serviceConceptData: ServiceConceptData) {}
  }

  @logDispatcher
  export class AddIntervalPrice {
    static readonly type = "[ServiceConcepts] AddIntervalPrice"
    constructor(public intervalPrice: IntervalPrice, public user: string) {}
  }

  @logDispatcher
  export class AddIntervalPriceSuccess {
    static readonly type = "[ServiceConcepts] AddIntervalPriceSuccess"
    constructor(public intervalPrice: IntervalPrice, public intervalId: number) {}
  }

  @logDispatcher
  export class EditIntervalPrices {
    static readonly type = "[ServiceConcepts] EditIntervalPrices"
    constructor(public conceptServiceId: number, public connectionId: string, public channel: string, public user: string) {}
  }

  @logDispatcher
  export class EditIntervalPricesSuccess {
    static readonly type = "[ServiceConcepts] EditIntervalPricesSuccess"
    constructor(public massiveResponse: MassiveResponse, public conceptServiceId: number) {}
  }

  @logDispatcher
  export class EditServiceConceptsTableCell {
    static readonly type = "[ServiceConcepts] EditServiceConceptsTableCell"
    constructor(public rowId: number, public fieldName: string, public newValue: any) {}
  }

  @logDispatcher
  export class EditIntervalPricesTableCell {
    static readonly type = "[ServiceConcepts] EditIntervalPricesTableCell"
    constructor(public conceptServiceId: number, public rowId: number, public fieldName: string, public newValue: any) {}
  }

  @logDispatcher
  export class AddDebRepayment {
    static readonly type = '[ServiceConcepts] AddDebRepayment';
    constructor(public user: string) { }
  }

  @logDispatcher
  export class AddDebRepaymentSuccess {
    static readonly type = '[ServiceConcepts] AddDebRepaymentSuccess';
    constructor(public debRepayment: DebRepaymentAddForm) { }
  }

  @logDispatcher
  export class EditDebRepayment {
    static readonly type = '[ServiceConcepts] EditDebRepayment';
    constructor(public editDebRepayment: DebRepaymentForm, public user: string) { }
  }

  @logDispatcher
  export class EditDebRepaymentSuccess {
    static readonly type = '[ServiceConcepts] EditDebRepaymentSuccess';
    constructor(public editDebRepayment: DebRepaymentForm) { }
  }

  @logDispatcher
  export class SetDebRepaymentAddFormDefaultState {
    static readonly type = '[ServiceConcepts] SetDebRepaymentAddFormDefaultState';
    constructor() { }
  }

  @logDispatcher
  export class AddContractDetail {
    static readonly type = '[ServiceConcepts] AddContractDetail';
    constructor(public user: string) { }
  }

  @logDispatcher
  export class AddContractDetailSuccess {
    static readonly type = '[ServiceConcepts] AddContractDetailSuccess';
    constructor(public contractDetail: ContractDetailsAddForm, public contractDetailId: number) { }
  }

  @logDispatcher
  export class EditContractDetail {
    static readonly type = '[ServiceConcepts] EditContractDetail';
    constructor(public editContractDetail: ContractDetailEditForm, public user: string) { }
  }

  @logDispatcher
  export class EditContractDetailSuccess {
    static readonly type = '[ServiceConcepts] EditContractDetailSuccess';
    constructor(public editContractDetail: ContractDetailEditForm) { }
  }

  @logDispatcher
  export class DeleteContractDetail {
    static readonly type = '[ServiceConcepts] DeleteContractDetail';
    constructor(public contractId: number, public contractDetailId: number) {}
  }

  @logDispatcher
  export class DeleteContractDetailSuccess {
    static readonly type = '[ServiceConcepts] DeleteContractDetailSuccess';
    constructor(public contractId: number, public contractDetailId: number) {}
  }

  @logDispatcher
  export class DeactivateServiceConcept {
    static readonly type = '[ServiceConcepts] DeactivateServiceConcept';
    constructor(public contractId: number, public conceptServiceId: number, public user: string) {}
  }

  @logDispatcher
  export class DeactivateServiceConceptSuccess {
    static readonly type = '[ServiceConcepts] DeactivateServiceConceptSuccess';
    constructor(public conceptServiceId: number) {}
  }

  @logDispatcher
  export class SetContractDetailsAddFormDefaultState {
    static readonly type = '[ServiceConcepts] SetContractDetailsAddFormDefaultState';
    constructor() { }
  }

  @logDispatcher
  export class Error {
      static readonly type = '[ServiceConcepts] Error';
      constructor(public error: any, public details: string) { }
  }

  @logDispatcher
  export class SetContractDataDefaultState  {
      static readonly type = '[ServiceConcepts] SetContractDataDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetServiceConceptDefaultState  {
      static readonly type = '[ServiceConcepts] SetServiceConceptDefaultState';
      constructor(public serviceConceptDefaults: ServiceConceptData) {}
  }

  @logDispatcher
  export class SetIntervalPriceDefaultState  {
      static readonly type = '[ServiceConcepts] SetIntervalPriceDefaultState';
      constructor(public intervalPriceDefaults: IntervalPrice) {}
  }

  @logDispatcher
  export class SetContractAddFormDefaultState  {
      static readonly type = '[ServiceConcepts] SetContractAddFormDefaultState';
      constructor() {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[ServiceConcepts] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetIsSubmitted {
    static readonly type = '[ServiceConcepts] SetIsSubmitted';
    constructor(public isSubmitted: boolean) {}
  }

  @logDispatcher
  export class SetIsEdited {
    static readonly type = '[ServiceConcepts] SetIsEdited';
    constructor(public isEdited: boolean) {}
  }
}
